import { SCORE_OPTIONS } from './score';
import { BOOKING_LOCATION_OPTIONS } from './customer';

export const STAGES = [
  {
    id: 'nurse',
    value: 'nurse',
    label: 'Nurse teleconsultation',
    shortLabel: 'Nurse',
    selected: true,
  },
  {
    id: 'fake',
    value: 'fake',
    label: 'Fake teleconsultation',
    shortLabel: 'Fake',
    selected: true,
  },
  {
    id: 'first',
    value: 'first',
    label: '1st teleconsultation',
    shortLabel: 'First',
    selected: true,
  },
  {
    id: 'second',
    value: 'second',
    label: '2nd teleconsultation',
    shortLabel: 'Second',
    selected: true,
  },
  {
    id: 'firstRenewal',
    value: 'firstRenewal',
    label: 'First renewal',
    shortLabel: 'First renewal',
    selected: true,
  },
  {
    id: 'annualRenewal',
    value: 'annualRenewal',
    label: 'Annual renewal',
    shortLabel: 'Annual renewal',
    selected: true,
  },
];

export const STATUSES = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'conducted',
    value: 'conducted',
    label: 'Conducted',
    selected: true,
  },
  {
    id: 'late-cancellation-by-patient',
    value: 'late-cancellation-by-patient',
    label: 'Late cancellation by patient',
    selected: true,
  },
  {
    id: 'timely-cancellation-by-patient',
    value: 'timely-cancellation-by-patient',
    label: 'Timely cancellation by patient',
    selected: true,
  },
  {
    id: 'no-show',
    value: 'no-show',
    label: 'No-show',
    selected: true,
  },
  {
    id: 'cancelled-by-host',
    value: 'cancelled-by-host',
    label: 'Cancelled by host',
    selected: true,
  },
];

export const MANUAL_PAYMENT_STATUSES = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'paid',
    value: 'paid',
    label: 'Paid',
    selected: true,
  },
  {
    id: 'not-required',
    value: 'not-required',
    label: 'Not required',
    selected: true,
  },
];

export const DOCTOR_PAYMENT_STATUSES = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'succeeded',
    value: 'succeeded',
    label: 'Succeeded',
    selected: true,
  },
  {
    id: 'failed',
    value: 'failed',
    label: 'Failed',
    selected: true,
  },
  {
    id: 'incomplete',
    value: 'incomplete',
    label: 'Incomplete',
    selected: true,
  },
];

export const BOOKING_REACH_STATUS_OPTIONS = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: false,
  },
  {
    id: 'in-progress',
    value: 'in-progress',
    label: 'In progress',
    selected: true,
  },
  {
    id: 'patient-confirmed',
    value: 'patient-confirmed',
    label: 'Patient confirmed',
    selected: false,
  },
  {
    id: 'patient-doesnt-want',
    value: 'patient-doesnt-want',
    label: "Patient doesn't want",
    selected: false,
  },
  {
    id: 'we-dont-want',
    value: 'we-dont-want',
    label: "We don't want",
    selected: false,
  },
  {
    id: 'cant-reach',
    value: 'cant-reach',
    label: "Can't reach",
    selected: false,
  },
  {
    id: 'other',
    value: 'other',
    label: 'Other',
    selected: false,
  },
];

export const CANCELLATION_REASONS = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'customer-didnt-understand-it-was-a-teleconsultation',
    value: 'customer-didnt-understand-it-was-a-teleconsultation',
    label: "Customer didn't understand it was a teleconsultation",
    selected: true,
  },
  {
    id: 'customer-prefers-to-see-their-gp',
    value: 'customer-prefers-to-see-their-gp',
    label: 'Customer prefers to see their GP',
    selected: true,
  },
  {
    id: 'customer-prefers-to-see-a-doctor-of-a-different-specialization',
    value: 'customer-prefers-to-see-a-doctor-of-a-different-specialization',
    label: 'Customer prefers to see a doctor of a different specialization',
    selected: true,
  },
  {
    id: 'customer-wants-a-consultation-earlier-than-we-can-offer',
    value: 'customer-wants-a-consultation-earlier-than-we-can-offer',
    label: 'Customer wants a consultation earlier than we can offer',
    selected: true,
  },
  {
    id: 'customer-is-outside-of-regional-coverage',
    value: 'customer-is-outside-of-regional-coverage',
    label: 'Customer is outside of regional coverage',
    selected: true,
  },
  {
    id: 'customer-cant-be-reimbursed',
    value: 'customer-cant-be-reimbursed',
    label: "Customer can't be reimbursed",
    selected: true,
  },
  {
    id: 'other',
    value: 'other',
    label: 'Other',
    selected: true,
  },
];

export const UNQUALIFIED_REASONS = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'customer-didnt-understand-it-was-a-teleconsultation',
    value: 'customer-didnt-understand-it-was-a-teleconsultation',
    label: "Customer didn't understand it was a teleconsultation",
    selected: true,
  },
  {
    id: 'customer-prefers-to-see-their-gp',
    value: 'customer-prefers-to-see-their-gp',
    label: 'Customer prefers to see their GP',
    selected: true,
  },
  {
    id: 'customer-prefers-to-see-a-doctor-of-a-different-specialization',
    value: 'customer-prefers-to-see-a-doctor-of-a-different-specialization',
    label: 'Customer prefers to see a doctor of a different specialization',
    selected: true,
  },
  {
    id: 'customer-wants-a-consultation-earlier-than-we-can-offer',
    value: 'customer-wants-a-consultation-earlier-than-we-can-offer',
    label: 'Customer wants a consultation earlier than we can offer',
    selected: true,
  },
  {
    id: 'customer-is-outside-of-regional-coverage',
    value: 'customer-is-outside-of-regional-coverage',
    label: 'Customer is outside of regional coverage',
    selected: true,
  },
  {
    id: 'customer-cant-be-reimbursed',
    value: 'customer-cant-be-reimbursed',
    label: "Customer can't be reimbursed",
    selected: true,
  },
  {
    id: 'other',
    value: 'other',
    label: 'Other',
    selected: true,
  },
];

export const NEXT_ACTIONS = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'waiting-for-doctors-decision',
    value: 'waiting-for-doctors-decision',
    label: "Waiting for doctor's decision",
    selected: true,
  },
  {
    id: 'schedule-1st-teleconsultation',
    value: 'schedule-1st-teleconsultation',
    label: 'Schedule 1st teleconsultation',
    selected: true,
  },
  {
    id: 'positional-treatment',
    value: 'positional-treatment',
    label: 'Positional treatment',
    selected: true,
  },
  {
    id: 'refer-to-treating-organization',
    value: 'refer-to-treating-organization',
    label: 'Refer to treating organization',
    selected: true,
  },
  {
    id: 'no-action-required',
    value: 'no-action-required',
    label: 'No action required',
    selected: true,
  },
  {
    id: 'schedule-a-pg',
    value: 'schedule-a-pg',
    label: 'Schedule a PG',
    selected: true,
  },
  {
    id: 'schedule-a-psg',
    value: 'schedule-a-psg',
    label: 'Schedule a PSG',
    selected: true,
  },
  {
    id: 'refer-to-psg',
    value: 'refer-to-psg',
    label: 'Refer to PSG',
    selected: true,
  },
  {
    id: 'reschedule-teleconsultation',
    value: 'reschedule-teleconsultation',
    label: 'Reschedule teleconsultation',
    selected: true,
  },
  {
    id: 'orthesis',
    value: 'orthesis',
    label: 'Orthesis',
    selected: true,
  },
  {
    id: 'ceinture-anti-ronflements',
    value: 'ceinture-anti-ronflements',
    label: 'Ceinture anti ronflements',
    selected: true,
  },
  {
    id: 'other',
    value: 'other',
    label: 'Other',
    selected: true,
  },
];

export const ADMIN_NEXT_ACTIONS = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'schedule-1st-teleconsultation',
    value: 'schedule-1st-teleconsultation',
    label: 'Schedule 1st teleconsultation',
    selected: true,
  },
  {
    id: 'schedule-a-pg',
    value: 'schedule-a-pg',
    label: 'Schedule a PG',
    selected: true,
  },
  {
    id: 'schedule-a-psg',
    value: 'schedule-a-psg',
    label: 'Schedule a PSG',
    selected: true,
  },
  {
    id: 'refer-to-psg',
    value: 'refer-to-psg',
    label: 'Refer to PSG (not via SleepDoctor)',
    selected: true,
  },
  {
    id: 'refer-to-treating-organization',
    value: 'refer-to-treating-organization',
    label: 'Refer to treating organization',
    selected: true,
  },
  {
    id: 'orthesis',
    value: 'orthesis',
    label: 'Orthesis',
    selected: true,
  },
  {
    id: 'ceinture-anti-ronflements',
    value: 'ceinture-anti-ronflements',
    label: 'Ceinture anti ronflements',
    selected: true,
  },
  {
    id: 'positional-treatment',
    value: 'positional-treatment',
    label: 'Positional treatment',
    selected: true,
  },
  {
    id: 'reschedule-teleconsultation',
    value: 'reschedule-teleconsultation',
    label: 'Reschedule teleconsultation',
    selected: true,
  },
  {
    id: 'waiting-for-doctors-decision',
    value: 'waiting-for-doctors-decision',
    label: "Waiting for doctor's decision",
    selected: true,
  },
  {
    id: 'no-action-required',
    value: 'no-action-required',
    label: 'No action required',
    selected: true,
  },
];

export const NURSE_NEXT_ACTIONS = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'schedule-1st-teleconsultation',
    value: 'schedule-1st-teleconsultation',
    label: 'Schedule 1st teleconsultation',
    selected: true,
  },
  {
    id: 'schedule-a-pg',
    value: 'schedule-a-pg',
    label: 'Schedule a PG',
    selected: true,
  },
  {
    id: 'schedule-a-psg',
    value: 'schedule-a-psg',
    label: 'Schedule a PSG',
    selected: true,
  },
  {
    id: 'refer-to-psg',
    value: 'refer-to-psg',
    label: 'Refer to PSG',
    selected: true,
  },
  {
    id: 'no-action-required',
    value: 'no-action-required',
    label: 'No action required',
    selected: true,
  },
  {
    id: 'reschedule-teleconsultation',
    value: 'reschedule-teleconsultation',
    label: 'Reschedule teleconsultation',
    selected: true,
  },
  {
    id: 'other',
    value: 'other',
    label: 'Other',
    selected: true,
  },
];

export const RENEWAL_NEXT_ACTIONS = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'waiting-for-doctors-decision',
    value: 'waiting-for-doctors-decision',
    label: "Waiting for doctor's decision",
    selected: true,
  },
  {
    id: 'refer-to-treating-organization',
    value: 'refer-to-treating-organization',
    label: 'Refer to treating organization',
    selected: true,
  },
  {
    id: 'no-action-required',
    value: 'no-action-required',
    label: 'No action required',
    selected: true,
  },
  {
    id: 'schedule-a-psg',
    value: 'schedule-a-psg',
    label: 'Schedule a PSG',
    selected: true,
  },
  {
    id: 'refer-to-psg',
    value: 'refer-to-psg',
    label: 'Refer to PSG',
    selected: true,
  },
  {
    id: 'reschedule-teleconsultation',
    value: 'reschedule-teleconsultation',
    label: 'Reschedule teleconsultation',
    selected: true,
  },
  {
    id: 'orthesis',
    value: 'orthesis',
    label: 'Orthesis',
    selected: true,
  },
  {
    id: 'ceinture-anti-ronflements',
    value: 'ceinture-anti-ronflements',
    label: 'Ceinture anti ronflements',
    selected: true,
  },
  {
    id: 'other',
    value: 'other',
    label: 'Other',
    selected: true,
  },
];

export const BOOKING_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'teleconsultations',
    type: 'itemAction',
    isFilterable: false,
    classNames: 'th-list-cellwidth-120',
    selected: true,
  },
  {
    label: 'Nurse',
    accessor: 'nurse',
    type: 'nurse',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
  {
    label: 'Event details',
    accessor: 'startTime',
    type: 'event',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Start date: Later first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'City',
    accessor: 'city',
    type: 'customerDetail',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Additional notes',
    accessor: 'notes',
    type: 'textWithEdit',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Location',
    accessor: 'location',
    type: 'customerSelect',
    isFilterable: true,
    options: BOOKING_LOCATION_OPTIONS,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    isFilterable: true,
    options: STATUSES,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Cancellation reason',
    accessor: 'cancellationReason',
    type: 'select',
    isFilterable: true,
    options: CANCELLATION_REASONS,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Next action',
    accessor: 'nextAction',
    type: 'select',
    isFilterable: true,
    options: NEXT_ACTIONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Reach-out status',
    accessor: 'reachOut',
    type: 'select',
    isFilterable: true,
    options: BOOKING_REACH_STATUS_OPTIONS,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Created at',
    accessor: 'createdAt',
    type: 'createdAt',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Score',
    accessor: 'score',
    type: 'customerDetail',
    isFilterable: true,
    options: SCORE_OPTIONS,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'GP situation',
    accessor: 'gpSituation',
    type: 'customerDetail',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
];

export const FIRST_TELE_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'teleconsultations',
    type: 'itemAction',
    isFilterable: false,
    classNames: 'th-list-cellwidth-120',
    selected: true,
  },
  {
    label: 'Doctor',
    accessor: 'doctor',
    type: 'doctor',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: false,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
  {
    label: 'Event details',
    accessor: 'startTime',
    type: 'event',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Start date: Later first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    options: STATUSES,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Cancellation reason',
    accessor: 'cancellationReason',
    type: 'select',
    isFilterable: true,
    options: CANCELLATION_REASONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Next action',
    accessor: 'nextAction',
    type: 'select',
    isFilterable: true,
    options: NEXT_ACTIONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Additional notes',
    accessor: 'notes',
    type: 'textWithEdit',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Score',
    accessor: 'score',
    type: 'customerDetail',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    options: SCORE_OPTIONS,
  },
];

export const SECOND_TELE_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'teleconsultations',
    type: 'itemAction',
    isFilterable: false,
    classNames: 'th-list-cellwidth-120',
    selected: true,
  },
  {
    label: 'Doctor',
    accessor: 'doctor',
    type: 'doctor',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: false,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
  {
    label: 'Event details',
    accessor: 'startTime',
    type: 'event',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Start date: Later first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    options: STATUSES,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Cancellation reason',
    accessor: 'cancellationReason',
    type: 'select',
    isFilterable: true,
    options: CANCELLATION_REASONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Next action',
    accessor: 'nextAction',
    type: 'select',
    isFilterable: true,
    options: NEXT_ACTIONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Additional notes',
    accessor: 'notes',
    type: 'textWithEdit',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Score',
    accessor: 'score',
    type: 'customerDetail',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    options: SCORE_OPTIONS,
  },
];

export const DOCTOR_TELE_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Event details',
    accessor: 'startTime',
    type: 'event',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Start date: Later first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    options: STATUSES,
    isFilterable: true,
    readOnly: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
];

export const DOCTOR_FIRST_TELE_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'teleconsultations',
    type: 'itemAction',
    isFilterable: false,
    classNames: 'th-list-cellwidth-120',
    selected: true,
  },
  {
    label: 'Event details',
    accessor: 'startTime',
    type: 'event',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Start date: Later first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Date of birth',
    accessor: 'dateOfBirth',
    type: 'customerDateOfBirth',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Health data',
    accessor: 'weight',
    type: 'healthData',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Score',
    accessor: 'score',
    type: 'customerDetail',
    selected: true,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    options: SCORE_OPTIONS,
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    options: STATUSES,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Cancellation reason',
    accessor: 'cancellationReason',
    type: 'select',
    isFilterable: true,
    options: CANCELLATION_REASONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Next action',
    accessor: 'nextAction',
    type: 'select',
    isFilterable: true,
    options: NEXT_ACTIONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Additional notes',
    accessor: 'notes',
    type: 'textWithEdit',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
];

export const DOCTOR_SECOND_TELE_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'teleconsultations',
    type: 'itemAction',
    isFilterable: false,
    classNames: 'th-list-cellwidth-120',
    selected: true,
  },
  {
    label: 'Event details',
    accessor: 'startTime',
    type: 'event',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Start date: Later first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    options: STATUSES,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Cancellation reason',
    accessor: 'cancellationReason',
    type: 'select',
    isFilterable: true,
    options: CANCELLATION_REASONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Next action',
    accessor: 'nextAction',
    type: 'select',
    isFilterable: true,
    options: NEXT_ACTIONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Additional notes',
    accessor: 'notes',
    type: 'textWithEdit',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
];

export const PSAD_RENEWAL_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Doctor',
    accessor: 'doctor',
    type: 'doctor',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: false,
    readOnly: true,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
  {
    label: 'Event details',
    accessor: 'startTime',
    type: 'event',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Start date: Later first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    options: STATUSES,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    readOnly: true,
  },
];

export const stageToStringMap = {
  first: '1st teleconsultation',
  second: '2nd teleconsultation',
  fake: 'Fake teleconsultation',
  nurse: 'Nurse teleconsultation',
  firstRenewal: 'First renewal teleconsultation',
  annualRenewal: 'Annual renewal teleconsultation',
};
